import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildVenueTypeCapsuleConfigSlice } from './config/configslice';
import { VenueAnalysisCapsuleState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleState';
import { VenueAnalysisCapsuleActionPayload } from 'widgets/venueAnalysis/capsules/store/actions';

const { reducer: configReducer } = buildVenueTypeCapsuleConfigSlice();

const venueTypeCapsuleWidgetReducer =
    combineReducers<VenueAnalysisCapsuleState>({
        config: configReducer,
    });

export const venueTypeCapsuleWidgetsReducer = createWidgetsReducer<
    VenueAnalysisCapsuleState,
    VenueAnalysisCapsuleActionPayload
>(WidgetType.VENUE_TYPE_CAPSULE, venueTypeCapsuleWidgetReducer);
